<template>
  <div
    class="flex flex-wrap bg-primary-500 sm:max-w-7xl md:max-w-none mx-auto px-6 lg:px-8 text-sm items-center py-4 gap-2 md:gap-0 justify-center"
  >
    <div class="md:w-1/3">
      <img class="h-4 w-auto" :src="logo" alt="Logo" data-cy="footer-logo" />
    </div>
    <div class="md:w-1/3 text-opposite-500 text-center">
      <div v-if="links && Object.keys(links).length" data-cy="footer-links">
        <p v-for="(url, name) in links" :key="url" class="flex justify-center" :data-cy="'footer-link-' + name">
          <template v-if="isHTML($t(url))">
            <span>{{ $t(`footer.${name}`) }}&nbsp;:&nbsp;</span>
            <html-textarea :value="$t(url)"></html-textarea>
          </template>
          <template v-else>
            <a :href="$t(url)" target="_blank" :data-cy="'footer-link-' + name" class="inline-block py-1"
              >{{ $t(`footer.${name}`) }}&nbsp;:&nbsp;{{ $t(url) }}</a
            >
          </template>
        </p>
      </div>
    </div>
    <div class="md:w-1/3 text-opposite-500 text-right">{{ $t('footer.copyright') }}</div>
  </div>
</template>

<script lang="ts" src="./footer.component.ts" />
